import React, { useEffect, useState } from "react";

import i18next from 'i18next'
import Creatable from "react-select/creatable";
import { PhotoIcon } from "@heroicons/react/24/solid";
import { authAxios } from "../../config/config";
import { toast } from "react-toastify";
import Select from 'react-select';
import { useSelector } from "react-redux";
import { correctContactValue, extractValues } from "../../Helper/helper";
import { useTranslation } from "react-i18next";

const UpdateFooter = ({ handleCancel, allmodel, handleUpdate }) => {
    const { i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';
    const [formData, setFormData] = useState({

        address: { en: "", ar: "" },
        description: { en: "", ar: "" },
        workingDays: { en: "", ar: "" },
        workingHours: { en: "", ar: "" },
        phone: "",
        email: "",
        facebook: "",
        instagram: "",
        twitter: "",
        linkedin: "",
        youtube:"",
    });







    const handleInputChange = (field, lang, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: typeof value === "object" ? value : { ...prev[field], [lang]: value },
        }));
    };







    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            contactInfo: {
                phone: formData.phone,
                email: formData.email,
                address: {
                    en: formData.address?.en || "",
                    ar: formData.address?.ar || "",
                },
                description: {
                    en: formData.description?.en || "",
                    ar: formData.description?.ar || "",
                }
            },
            socialLinks: {
                facebook: formData.facebook || "",
                twitter: formData.twitter || "",
                instagram: formData.instagram || "",
                linkedin: formData.linkedin || "",
                youtube:formData.youtube||''
            },
            workingDays: {
                en: formData.workingDays?.en || "",
                ar: formData.workingDays?.ar || "",
            },
            workingHours: {
                en: formData.workingHours?.en || "",
                ar: formData.workingHours?.ar || "",
            }
        };



        handleUpdate(payload);



    };




    useEffect(() => {
        if (allmodel?.data?._id) {
            // Populate the formData state with existing data for updating
            setFormData({
                address: {
                    en: allmodel.data.contactInfo.address.en || "",
                    ar: allmodel.data.contactInfo.address.ar || "",
                },
                description: {
                    en: allmodel.data.contactInfo.description.en || "",
                    ar: allmodel.data.contactInfo.description.ar || "",
                },
                workingDays: {
                    en: allmodel.data.workingDays.en || "",
                    ar: allmodel.data.workingDays.ar || "",
                },
                workingHours: {
                    en: allmodel.data.workingHours.en || "",
                    ar: allmodel.data.workingHours.ar || "",
                },
                phone: allmodel.data.contactInfo.phone || "",
                email: allmodel.data.contactInfo.email || "",
                facebook: allmodel.data.socialLinks.facebook || "",
                instagram: allmodel.data.socialLinks.instagram || "",
                twitter: allmodel.data.socialLinks.twitter || "",
                linkedin: allmodel.data.socialLinks.linkedin || "",
                youtube: allmodel.data.socialLinks.youtube || "",

            });
        }
    }, []); // Re-run when the `allmodel` changes







    return (
        <div className="fixed inset-0 z-10">
            <div className="fixed inset-0 bg-gray-500/75 transition-opacity"></div>
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-screen items-center justify-center p-4 sm:p-6 lg:p-8 text-center">
                    <div className="relative transform overflow-hidden bg-white rounded-lg shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                        <div className="px-6 py-8">
                            <h2 className="text-lg font-medium text-gray-900 mb-6">
                                {allmodel?.data?._id ? "Update Footer" : "Add Footer"}
                            </h2>
                            <div className="flex items-center gap-4">
                                <label className="flex-1 text-sm font-medium text-gray-900 flex items-center justify-start mb-2"></label>
                                <label className="flex-1 text-sm font-medium text-gray-900 flex items-center justify-start mb-2">English </label>
                                <label className="flex-1 text-sm font-medium text-gray-900 flex items-center justify-start mb-2">Arabic</label>
                            </div>
                            <form onSubmit={handleSubmit} className="space-y-6">
                                {["workingDays", "workingHours", "address", "description"].map((field) => (
                                    <div key={field} className="flex items-center gap-4">
                                        <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">
                                            {field.charAt(0).toUpperCase() + field.slice(1)}
                                        </label>
                                        <input
                                            type="text"
                                            placeholder={`${field} (EN)`}
                                            required
                                            value={formData[field]?.en || ""}
                                            onChange={(e) => handleInputChange(field, "en", e.target.value)}
                                            className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                        />
                                        <input
                                            type="text"
                                            placeholder={`${field} (AR)`}
                                            value={formData[field]?.ar || ""}
                                            onChange={(e) => handleInputChange(field, "ar", e.target.value)}
                                            required
                                            className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                        />
                                    </div>
                                ))}



                                <div className="flex items-center gap-4">
                                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Contact Number</label>
                                    <input
                                        required
                                        type="text"
                                        placeholder="Contact Number"
                                        value={formData.phone}
                                        onChange={(e) => setFormData({ ...formData, phone: correctContactValue(e.target.value) })}
                                        className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                    />
                                </div>

                                <div className="flex items-center gap-4">
                                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Email</label>
                                    <input
                                        required
                                        type="email"
                                        placeholder="Email"
                                        value={formData.email}
                                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                        className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                    />
                                </div>




                                <div className="flex items-center gap-4">
                                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Social Links</label>
                                    <div className="grid grid-cols-2 gap-4">
                                        {[
                                            { field: "linkedin", label: "Linked In" },
                                            { field: "facebook", label: "Facebook URL" },
                                            { field: "instagram", label: "Instagram URL" },
                                            { field: "twitter", label: "Twitter URL" },
                                            { field: "youtube", label: "Youtube URL" },

                                            // { field: "youtube", label: "Yotube URL" },
                                        ].map(({ field, label }) => (
                                            <input
                                                key={field}
                                                type="text"
                                                placeholder={label}
                                                value={formData[field] || ""}
                                                onChange={(e) => setFormData({ ...formData, [field]: e.target.value })}
                                                className="w-full rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                            />
                                        ))}
                                    </div>
                                </div>




                                <div className="flex gap-2 mt-4">
                                    <button
                                        type="button"
                                        onClick={handleCancel}
                                        className="w-1/2 rounded-md bg-gray-500 px-4 py-3 text-white hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 sm:text-sm"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="w-1/2 rounded-md bg-indigo-600 px-4 py-3 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-sm"
                                    >
                                        {allmodel?.data?._id ? "Update" : "Add"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateFooter;
